import React, { useState, useEffect } from 'react';
import { useOrganization } from '../contexts/OrganizationContext';
import DepartmentList from '../components/admin/DepartmentList';
import UserList from '../components/admin/UserList';
import CreateDepartment from '../components/admin/CreateDepartment';
import { Department, Organization } from '../types';
import axios from 'axios';

export default function DepartmentManagementPage() {
  const { currentContext } = useOrganization();
  const [departments, setDepartments] = useState<Department[]>([]);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchDepartments = async () => {
    if (!currentContext.organization_id) return;
    
    try {
      setIsLoading(true);
      const response = await axios.get(`/api/organizations/${currentContext.organization_id}/departments`);
      setDepartments(response.data);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to fetch departments');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, [currentContext.organization_id]);

  const handleDepartmentSelect = (departmentId: string | null) => {
    setSelectedDepartmentId(departmentId);
  };

  const handleDepartmentsChange = () => {
    fetchDepartments();
  };

  if (isLoading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  if (error) {
    return <div className="text-red-500 p-4">{error}</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold">Department and User Management</h1>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Department Tree Section */}
        <div className="lg:col-span-1">
          <DepartmentList
            organization={{ 
              id: currentContext.organization_id || '', 
              name: currentContext.organization_name || '' 
            }}
            departments={departments}
            onDepartmentSelect={handleDepartmentSelect}
            onDepartmentsChange={handleDepartmentsChange}
            showCreateButton={true}
          />
        </div>

        {/* User Management Section */}
        <div className="lg:col-span-2">
          <UserList departmentId={selectedDepartmentId || undefined} />
        </div>
      </div>
    </div>
  );
} 